
























































































































import { computed, ref, watch } from '@vue/composition-api';
import { asyncThrottle } from '@/utils/utils';
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    patientId: {
      type: String,
      default: '',
    },
    isFromImport: {
      type: Boolean,
      default: false,
    },
    justSelect: {
      type: Boolean,
      default: false,
    },
    tagSelectedList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit, root }: any) {
    const computedShow = computed({
      get() {
        return props.show;
      },
      set() {
        closeDialog();
      },
    });

    const closeDialog = () => {
      emit('change', false);
    };

    const keyword = ref('');
    const radio = ref(1);

    const isKeywordEmpty = computed(() => keyword.value === '');

    const query = ref({ currentPage: 0, pageSize: 20 });
    const customLabelList = ref<any>([]);

    const onKeywordSearch = async () => {
      query.value.currentPage = 0;
      getSearchList();
    };
    const highlightMatch = (text) => {
      if (!keyword.value) return text;
      const regex = new RegExp(`(${keyword.value})`, 'i');

      return text.replace(regex, `<span style="color: #F79B31;">${keyword.value}</span>`);
    };

    const isSelected = computed(() => item => selectedList.value.some(e => e.tagName + e.TagValue === item.tagName + item.TagValue));

    const selectedList = ref<any[]>([]);

    const tagList = ref<any[]>([]);
    const total = ref(0);
    const getTagList = async () => {
      const { err, tagTypeList } = await root.$http.post('/tag/getSearchTagList', {
        pageSize: 10,
      });
      if (err) throw Error('弹窗拦截');
      tagList.value = tagTypeList?.map(item => ({ ...item, currentPage: 0 })) || [];

      if (tagTypeList?.length) total.value = tagList.value.reduce((acc, cur) => acc + cur.total, 0);
    };

    const searchList = ref<any[]>([]);
    const getSearchList = async () => {
      if (keyword.value === '') {
        getTagList();
        searchList.value = [];
        return;
      };
      const {
        err,
        list,
        total: searchTotal,
      } = await root.$http.post('/tag/getTagValueList', {
        key: keyword.value,
        ...query.value,
      });
      if (err) throw Error('弹窗拦截');
      if (query.value.currentPage === 0) {
        searchList.value = list || [];
      } else {
        searchList.value = [...searchList.value, ...list];
      }
      total.value = searchTotal || 0;
    };
    const getMore = async (tagTypeId) => {
      const group = tagList.value.find(item => item.tagTypeId === tagTypeId);
      group.currentPage += 1;
      const { err, list } = await root.$http.post('/tag/getTagValueList', {
        pageSize: 10,
        currentPage: group.currentPage,
        tagTypeId,
      });
      if (err) throw Error('弹窗拦截');
      group.list = [...group.list, ...list];
    };

    const onTagClick = (item) => {
      console.log('click', item);
      const index = selectedList.value.findIndex(e => e.tagName + e.TagValue === item.tagName + item.TagValue);
      if (index !== -1) {
        selectedList.value.splice(index, 1);
      } else selectedList.value.push(item);
      console.log('selected', selectedList.value);
    };

    const init = async () => {
      getTagList();
      if (!props.isFromImport) {
        selectedList.value = root.$store.state.tagFilterSelectedList;
        radio.value = root.$store.state.query.opType;
      }
      const length = props.tagSelectedList.length;
      if (length === 0) selectedList.value = [];
      else if (length < selectedList.value.length) {
        selectedList.value = selectedList.value.filter(item => props.tagSelectedList.includes(item.TagValue));
      }
    };
    watch(
      () => props.show,
      (val) => {
        if (val) {
          // const modalArr = document.getElementsByClassName('v-modal');
          // console.log(modalArr, 'modalArr', modalArr[0]);
          // if (modalArr?.length) (modalArr[0] as HTMLElement).style.zIndex = '3499';
          query.value.currentPage = 0;
          keyword.value = '';
          init();
        }
      },
      {
        immediate: true,
      },
    );

    const confirm = async () => {
      console.log('selected', selectedList.value);
      if (!props.isFromImport) root.$store.commit('SET_TAGFILTERSELECTEDLIST', selectedList.value);
      const systemTags: any[] = [];
      const customTags: any[] = [];

      selectedList.value.forEach((item) => {
        // 系统标签
        if (item.classify === 1) {
          const group = systemTags.find(ele => ele.tagName === item.tagName);
          if (group) {
            group.tagValues.push(item.TagValue);
          } else {
            systemTags.push({
              tagName: item.tagName,
              tagValues: [item.TagValue],
            });
          }
        } else if (item.classify === 2) {
          // 自定义标签
          const group = customTags.find(ele => ele.tagName === item.tagName);
          if (group) {
            group.tagValues.push(item.TagValue);
          } else {
            customTags.push({
              tagName: item.tagName,
              tagValues: [item.TagValue],
            });
          }
        }
      });

      const params = {
        opType: radio.value,
        systemTags,
        customTags,
      };
      console.log('params', params);

      emit('confirm', params);
      closeDialog();
    };

    const load = asyncThrottle(async () => {
      query.value.currentPage += 1;
      getSearchList();
    });

    return {
      computedShow,
      customLabelList,
      closeDialog,
      confirm,

      load,
      keyword,
      onKeywordSearch,
      highlightMatch,
      radio,
      total,
      tagList,
      selectedList,
      onTagClick,
      searchList,
      getMore,
      isSelected,
      isKeywordEmpty,
    };
  },
};
